export default __webpack_public_path__ + "static/media/regulatory--maximum-speed-limit-led-25--g2.9a69ae6f.png";